export default __webpack_public_path__ + "static/media/school_resell_for_school.853f2f62.svg";